import { Modal } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { Severty, ShowToast } from "../helper/toast";

import CopyLinkIcon from "../assets/images/media-share-icon/copy-link.svg";
import YouTubeLinkIcon from "../assets/images/media-share-icon/youtube.svg";
import TwitchLinkIcon from "../assets/images/media-share-icon/twich-icon.svg";
import InstagramLinkIcon from "../assets/images/media-share-icon/instagram-icon.svg";
import KickLinkIcon from "../assets/images/media-share-icon/kick-icon.svg";

const UniversalShareModal = ({
  open,
  onClose,
  url,
  platforms,
  toast,
  title = "Share",
}) => {
  return (
    <div>
      <Modal
        width={400}
        title={title}
        open={open}
        onOk={onClose}
        onCancel={onClose}
        footer={false}
        className="custom-modal"
      >
        <div className="share-button-list">
          <Link
            onClick={async () => {
              await navigator.clipboard.writeText(url);
              ShowToast("Link copied!", Severty.SUCCESS);
              onClose();
            }}
            className="share-btn-modal"
          >
            <img src={CopyLinkIcon} alt="copy link" />
            <p>Copy Link</p>
          </Link>
          <Link to="https://www.youtube.com/" className="share-btn-modal">
            <img src={YouTubeLinkIcon} alt="youtube" />
            <p>YouTube</p>
          </Link>
          <Link to="https://www.twitch.tv/" className="share-btn-modal">
            <img src={TwitchLinkIcon} alt="twitch" />
            <p>Twitch</p>
          </Link>
          <Link to="https://www.instagram.com/" className="share-btn-modal">
            <img src={InstagramLinkIcon} alt="instagram" />
            <p>Instagram</p>
          </Link>
          <Link to="https://kick.com/" className="share-btn-modal">
            <img src={KickLinkIcon} alt="kick" />
            <p>Kick</p>
          </Link>
        </div>
      </Modal>
    </div>
  );
};

export default UniversalShareModal;
